var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThemeSwitcher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 86 86"
    },
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 42.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2 25.8c2.4 5.9 2.1 11.5-2.1 16.3-4.3 4.9-9.8 6-16.1 4.2.1.5.2 1.1.4 1.5 1.5 3.3 3.8 5.8 7 7.6 2.9 1.6 6 2.3 9.3 2 3.4-.3 6.5-1.6 9.1-4 1-1 2-2 2.8-3.1 1.6-2.5 2.6-5.2 2.6-8.3 0-2.5-.3-5-1.4-7.3-1.1-2.3-2.6-4.3-4.6-5.9-2-1.5-4.2-2.7-7-3z",
    className: "st1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeSwitcher);
export default __webpack_public_path__ + "static/media/theme_switcher.20e3f07709967917d6691c92c8065d7a.svg";
export { ForwardRef as ReactComponent };